import * as React from 'react';
import { IndexRoute, Redirect, Route } from 'react-router';

import user from 'js/lib/user';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import FrontPageApplication from 'bundles/front-page/components/FrontPageApplication';
import NotFound from 'bundles/phoenix/components/NotFound';

const FrontPage = loadOnRoute(() => import('bundles/front-page/components/FrontPage'));

const routes = (
  <CourseraRoute
    handle={{
      tracking: {
        data: () => ({
          page: { segment: 'consumer' },
        }),
      },
    }}
  >
    <CourseraRoute
      path="/frontpage"
      component={FrontPageApplication}
      handle={{
        tracking: {
          data: () => ({
            page: { type: 'lohp' },
          }),
        },
      }}
    >
      <IndexRoute getComponent={FrontPage} />
    </CourseraRoute>

    <CourseraRoute
      path="/"
      component={FrontPageApplication}
      handle={{
        tracking: {
          data: () => ({
            page: { type: user.isAuthenticatedUser() ? 'lihp' : 'lohp' },
          }),
        },
      }}
    >
      <IndexRoute getComponent={FrontPage} />
      <Route path="/in" getComponent={FrontPage} />
      <Redirect from="/accomplishments" to="/" />
      <Redirect from="/notifications" to="/" />
      <Redirect from="/recommendations" to="/" />
      <Redirect from="/account-settings" to="/" />
      <Route path="*" component={NotFound} />
    </CourseraRoute>
  </CourseraRoute>
);

export default routes;
